import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import './Celestial.css';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import User from '../../User';
import Collectable from './Collectable';

export default class Celestial extends Component {

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    let src = this.props.src;
    let manager = this.props.manager;

    let devotion = User.data.devotion[src.model.devotion];

    const requirement = User.devotionRequirement(devotion.rank);
    const progressRatio = src.model.devotion === "maze"
      ? src.offeringProgress
      : Math.max(0, Math.min(1, devotion.progress / requirement));
    const isNilith = src.model.devotion === "maze";
    let size = isNilith ? 30 + (devotion.rank - 1 + (progressRatio >= 1 ? 0 : progressRatio)) * 25 : devotion.rank * 5 + progressRatio * 5;
    let scale = 0.6 + size * 0.004;
    let spiritOffset = Math.max(0, 40 - size * 0.2);
    let devoting = src.active && src.collectables.length === 0;
    
    return (
      <div className={"spirit-scene spirit-" + src.model.key}>
        <div className="game-spirit" style={{transform: "scale(" + scale + ") translateX(" + spiritOffset + "vh)"}}>
          <Img className="game-spirit-img" src={this.props.src.model.img}/>
        </div>
        {
          src.collectables.length > 0 &&
          <div className="celestial-collectables">
            {
              src.collectables.map((collectable,i) =>
                <Collectable
                onSelect={() => manager.run.room.celestial.take(i)}
                src={collectable}
                id={"celestial-collectable-" + i}
                key={"celestial-collectable-" + i}
                />
              )
            }
          </div>
        }
        {
          devoting &&
          <div id="spirit-gauge" className="spirit-gauge">
            <div className="spirit-rank">
              <Img className="spirit-icon" src={"/images/" + src.model.key + ".png"}/>
              <div className="spirit-rank-value">{devotion.rank || ""}</div>
            </div>
            <div className="spirit-bar">
              <div className="spirit-bar-fill" style={{clipPath: "inset(0 " + ((1 - progressRatio) * 100) + "% 0 0)"}}/>
              <div className="spirit-bar-label">{src.model.devotion === "maze" ? Math.round(progressRatio * 100) + "%" : devotion.progress + " / " + requirement + " exp"}</div>
            </div>
          </div>
        }
        { devoting && <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "spirit-gauge"} target="spirit-gauge" toggle={() => this.toggleTooltip("spirit-gauge")}><b>{translate("[name]'s blessing").replace('[name]', src.model.name)}</b><br/>{src.model.tooltip}</Tooltip> }
        {
          devoting &&
          <div className="fountain-choices spirit-choices">
          <div key="fountain-choice-text" className="fountain-choice-text">
            {src.model.dialog}
          </div>
          {
            src.choices.map((c,i) => 
                <div key={i} className={"fountain-choice" + (c.disabled ? " locked" : "") + (c.type === "surrender" && src.surrendered ? " celestial-surrender-committed" : "")} onClick={() => !c.disabled && manager.run.room.celestial.select(c.type)}>
                  {
                      (() => {
                        switch (c.type) {
                        case "surrender": return (
                          <div className="fountain-choice-inner">
                            <span><Img className="choice-spirit-icon" src={`/images/exp.png`} alt="" />{translate("Surrender your exp")} <span className="celestial-surrender-exp">{"(" + src.remainingExp + " exp)"}</span></span>
                          </div>
                          );
                        case "dive": return (
                          <div className="fountain-choice-inner">
                            <span><Img className="choice-spirit-icon" src={`/images/divein.png`} alt="" />{translate("Dive in")}</span>
                          </div>
                          );
                        case "end": return (
                          <div className="fountain-choice-inner">
                            <span>{translate("End your run")}</span>
                          </div>
                          );
                        default: return null;
                        }
                      })()
                    }
                </div>
            )
          }
          </div>
        }
      </div>
    );
  }
}

